import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大吃瓜频道，满足你的所有八卦需求，点击进入你想看的吃瓜世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat, index) => {
            const isLarge = index === 2;
            const isDark = index === 0;
            const isImageBg = index === 3;

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group relative rounded-xl overflow-hidden transition-all hover:-translate-y-1 cursor-pointer ${
                  isLarge ? 'lg:col-span-1' : ''
                }`}
              >
                {isDark ? (
                  <div className="bg-foreground-900 p-6 h-48 flex flex-col justify-between">
                    <div className="w-10 h-10 rounded-lg bg-background-50/10 flex items-center justify-center mb-3">
                      <i className={`${cat.icon} text-background-50 text-lg`}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-heading font-bold text-background-50 mb-1">{cat.name}</h3>
                      <p className="text-xs text-background-50/50">{cat.description}</p>
                      <span className="inline-block mt-2 text-xs text-background-50/40">{cat.count} 篇吃瓜</span>
                    </div>
                  </div>
                ) : isImageBg ? (
                  <div className="relative h-48">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20video%20production%20setup%20with%20professional%20camera%20and%20monitor%20screen%2C%20warm%20studio%20lighting%2C%20creative%20workspace%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20with%20soft%20shadows%2C%20dark%20background%20with%20warm%20accents%2C%20high%20detail%20composition&width=600&height=400&seq=cat-video-bg&orientation=landscape"
                      alt={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                    <div className="absolute top-3 left-3">
                      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-background-50/20 backdrop-blur-sm text-background-50 text-xs">
                        <i className={`${cat.icon} text-sm`}></i>
                        {cat.name}
                      </span>
                    </div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <p className="text-background-50 text-sm font-medium">{cat.description}</p>
                    </div>
                  </div>
                ) : (
                  <div className="bg-background-50 border border-background-200/70 p-6 h-48 flex flex-col">
                    <div className="flex-1">
                      <h3 className="text-2xl font-heading font-bold text-foreground-950 mb-2">{cat.name}</h3>
                      <p className="text-xs text-foreground-600">{cat.description}</p>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-500">{cat.count} 篇吃瓜</span>
                      <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                        <i className={`${cat.icon} text-primary-600 text-sm`}></i>
                      </div>
                    </div>
                  </div>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}